import React from 'react';

import styles from "./styles/ChatThreads.module.scss";

import { CardTitle, Description, SubTitle, Title } from 'Components/CustomComponents';
import { Image, Spinner } from 'react-bootstrap';
import { useChatContext } from '../context/ChatContext';
import { formatTimestamp } from 'Helper';
import _ from 'lodash';



const ChatThreads: React.FC = () => {
    const { chatThread, resetMessageCount, setChatRoom } = useChatContext()

    const handleThreadClick = (item: ChatThreadType) => {
        setChatRoom(item);
        resetMessageCount(item?.chat_room_id)
        // if (searchParams.get('user')) {
        //     const params = new URLSearchParams(searchParams.toString())
        //     params.delete('user')
        //     navigate(`${location}?${params}`)
        // }
    }

    return (
        <div className={styles.ChatThreads}>
            <div className={styles.titleContainer}>
                <SubTitle
                    text='Chat'
                    classes='mb-2'
                />
            </div>
            <div className={styles.threads}>
                {chatThread?.isLoading ?
                    <div className='make-center'> <Spinner /></div> :
                    !chatThread?.data?.length ? <div className='make-center'> <Title text="Empty Chat Threads" /></div> :
                        chatThread?.data?.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className={`${styles.thread} ${item?.unread_message_count ? "active" : ""}`}
                                    onClick={() => handleThreadClick(item)}

                                >
                                    <Image
                                        className={styles.userImage}
                                        src={item?.image_url}
                                        width={60}
                                        height={60}
                                        alt='User Profile'
                                    />
                                    <div className={styles.infoContainer}>
                                        <div className={styles.userInfo}>
                                            <div className={styles.nameContainer}>
                                                <CardTitle
                                                    text={item?.room_name}
                                                    classes='fs-6 lc-1'
                                                />
                                            </div>
                                            <Description
                                                text={item?.message?.message}
                                                classes='mt-1 pe-1 lc-1 w-85'
                                            />
                                        </div>
                                        <div className={styles.messageInfo}>
                                            {_.isEmpty(item?.message) ? "" : <span className={styles.time}>{formatTimestamp(item.message?.createdAt ?? '')}</span>}
                                            {item?.unread_message_count > 0 ? <span className={styles.indicator}>{item?.unread_message_count}</span> : ""}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}

            </div>
        </div>
    )
}

export default ChatThreads